import React, { useState } from 'react';
import './OceanConservationPrograms.css';

const programs = [
  { icon: '🪸', title: 'Coral Reef Restoration', color: '#ff6b6b', description: 'Coral reefs are among the most diverse ecosystems on the planet, but they are increasingly under threat due to climate change and human activities. This program involves the restoration of coral reefs through coral gardening, transplantation, and community education efforts. Volunteers will participate in underwater restoration, assist with nursery maintenance, and learn about reef ecosystems.' },
  { icon: '♻️', title: 'Ocean Cleanup Initiative', color: '#00b4d8', description: 'Plastic pollution is one of the biggest threats to marine life. The Ocean Cleanup Initiative organizes large-scale beach cleanups and offshore plastic collection efforts to reduce the waste entering our oceans. Volunteers will join cleanup teams, help raise awareness about pollution prevention, and participate in recycling drives and educational outreach.' },
  { icon: '🐬', title: 'Marine Wildlife Monitoring', color: '#ffa62b', description: 'This program focuses on protecting endangered marine species such as sea turtles, dolphins, and sharks. Volunteers assist in tracking animal populations, monitoring nesting sites, and collecting data on habitat health. The information gathered helps scientists develop conservation strategies to ensure the long-term survival of these species.' },
  { icon: '🚯', title: 'Plastic Pollution Awareness', color: '#a855f7', description: 'Raise awareness about the dangers of plastic pollution to our oceans. Volunteers in this program will engage in community outreach to educate people about reducing single-use plastics, organizing eco-friendly workshops, and promoting sustainable lifestyles.' },
  { icon: '🐟', title: 'Sustainable Fishing Practices', color: '#22c55e', description: 'Overfishing is a major issue that impacts marine biodiversity and ecosystem health. This program collaborates with local fishermen to encourage sustainable fishing practices, promotes alternative livelihoods, and supports the development of marine-protected areas.' },
  { icon: '🏖️', title: 'Beach Conservation Events', color: '#f59e0b', description: 'Coastal ecosystems are critical for marine life, but human activities threaten their existence. Volunteers participate in regular beach cleanups, conservation events, and educational workshops to maintain clean beaches and protect sensitive coastal habitats.' },
  { icon: '🌡️', title: 'Climate Change Advocacy', color: '#ef4444', description: 'Climate change poses a significant risk to ocean ecosystems. This program focuses on advocacy and raising awareness about the effects of global warming on oceans. Volunteers participate in climate campaigns, policy advocacy efforts, and organize community-driven initiatives.' },
  { icon: '🔬', title: 'Ocean Research Expeditions', color: '#0097b2', description: 'Ocean research expeditions offer the opportunity to directly contribute to scientific understanding of marine ecosystems. Volunteers on these expeditions assist with data collection on water quality, marine biodiversity, and human impact studies.' },
];

const OceanConservationPrograms = () => {
  const [toast, setToast] = useState({ show: false, message: '' });
  const [appliedPrograms, setAppliedPrograms] = useState(new Set());

  const handleApply = (title) => {
    setAppliedPrograms(prev => new Set([...prev, title]));
    setToast({ show: true, message: `Successfully registered for ${title}!` });
    setTimeout(() => setToast({ show: false, message: '' }), 3500);
  };

  return (
    <div className="programs-page">
      {/* Toast */}
      {toast.show && (
        <div className="programs-toast">
          <span>✅</span> {toast.message}
        </div>
      )}

      <div className="programs-container">
        <div className="programs-header">
          <span className="programs-badge">🌊 Make A Difference</span>
          <h1>Ocean Conservation Programs</h1>
          <p className="programs-subtitle">Choose a program and join our global community of ocean protectors. Every volunteer makes a difference.</p>
        </div>

        <div className="programs-grid">
          {programs.map((program, index) => (
            <div className="program-card" key={index} style={{ '--accent': program.color }}>
              <div className="program-icon">{program.icon}</div>
              <h2 className="program-title">{program.title}</h2>
              <p className="program-description">{program.description}</p>
              <button 
                className={`apply-btn ${appliedPrograms.has(program.title) ? 'applied' : ''}`} 
                onClick={() => handleApply(program.title)}
                disabled={appliedPrograms.has(program.title)}
              >
                {appliedPrograms.has(program.title) ? '✓ Applied' : 'Apply Now'}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OceanConservationPrograms;
